import React from 'react';

const GradientDetailLayout = ({ children }) => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-tr from-orange-100 via-white to-yellow-200/30">
      <div className=" w-full  min-h-screen shadow-sm">
        {children}
      </div>
    </div>
  );
};

export default GradientDetailLayout;